module.exports = __webpack_public_path__ + "media/images/bg-header-bf17ff851dd1eb957362e9302f79ee65.webp";